import type {
    LegacyCheckoutStatus,
    OrderStatus,
    PaymentStatus,
    RedirectionInstructions,
} from '@eventbrite/checkout-fairy-api';
import { TlzEnvironment, _getOrderComposedStatusUrl } from '../constants';

export const getOrderComposedStatus = async ({
    env,
    eventId,
    orderId,
}: {
    env: TlzEnvironment;
    eventId: string;
    orderId: string;
}): Promise<{
    orderStatus: OrderStatus;
    paymentStatus: PaymentStatus | null;
    redirectionInstructions: RedirectionInstructions | null;
    status: LegacyCheckoutStatus;
}> => {
    const response = await fetch(
        _getOrderComposedStatusUrl({
            env,
            eventId,
            orderId,
        }),
        {
            method: 'GET',
            credentials: 'include',
        },
    );

    let body = null;

    try {
        body = await response.json();
    } catch (error) {
        throw new Error(
            `CheckoutStatusAPI returned an error: ${error.message}`,
        );
    }

    if (body.error) {
        throw new Error(
            `CheckoutStatusAPI returned a body describing an error: ${body.error} (full body: ${body})`,
        );
    }

    return body;
};
